<div class="d-inline-flex flex-wrap justify-content-between width-100" *ngIf="dataLength > 0 && !jobSearchForm.isLoadingSearch ">
    <div [class.invisible]="showTitle === false">
        <h2 class="mgn-bottom-15 mgn-rigth-30 section-title-h2">Anuncios disponibles</h2>
    </div>
    <div class="d-flex flex-wrap" *ngIf="dataLength>0">
        <p class="applicant-search-counter font-size-14 mgn-rigth-30 mgn-top-5">Mostrando&nbsp;<span class="text-primary">
                <span class="font-weight-bold"> {{dataLength}}</span>&nbsp;de&nbsp;
                <span class="font-weight-bold">{{recordsCount}}</span>&nbsp;anuncios
            </span>

        </p>
        <form [formGroup]="jobSearchForm._formGroupSearch" class="d-flex flex-wrap">
            <div>
                <label for="teacher-advm-search-result-sort" class="font-size-14 mgn-rigth-12 mgn-top-5">Ordenar
                    por:</label>
            </div>
            <div class="mgn-bottom-25">

                <select id="teacher-advm-search-result-sort" class="form-control" formControlName="optionOrder">
                    <option value="SORT1" selected>Últimos anuncios</option>
                    <option value="SORT2">Próximos a vencer</option>
                    <option value="SORT3">Comuna (A-Z)</option>
                    <option value="SORT4">Comuna (Z-A)</option>
                </select>


            </div>
        </form>
    </div>
</div>